const features = [
  {
    icon: 'ri-notification-3-line',
    title: '智能追更提醒',
    desc: '订阅漫画后自动推送更新通知，支持多部漫画同时追踪，第一时间获知最新话发布动态，追更不再遗漏。',
    color: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '优化下拉式追更体验，像刷社交媒体一样流畅阅读漫画，告别传统翻页的割裂感，沉浸感大幅提升。',
    color: 'bg-accent-100',
    iconColor: 'text-accent-600',
  },
  {
    icon: 'ri-global-line',
    title: '韩日国全覆盖',
    desc: '覆盖韩漫、日漫、国漫三大品类，从都市情感到奇幻冒险、从悬疑推理到科幻巨制，多元题材一站追更。',
    color: 'bg-secondary-200',
    iconColor: 'text-secondary-700',
  },
  {
    icon: 'ri-book-open-line',
    title: '免费全集资源',
    desc: '海量漫画免费全集持续更新，无需付费即可畅读完整内容，热门韩漫日漫国漫全部免费追更。',
    color: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '追更日历规划',
    desc: '一览本周所有连载漫画的更新时间表，合理安排追更计划，不错过任何一部心头好的更新日。',
    color: 'bg-accent-100',
    iconColor: 'text-accent-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            女神漫画网为追更而生，五大核心功能让你的追更之旅更轻松
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 mx-auto flex items-center justify-center rounded-full ${item.color} mb-4`}>
                <i className={`${item.icon} text-2xl ${item.iconColor}`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}